export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./jackpot-list.vue?vue&type=template&id=20c54391&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/jackpot-list.vue?vue&type=template&id=20c54391&scoped=true
// module id = 8Md1
// module chunks = 0